/**
 * Names the one account a search should return.
 */
export class AccountSearchFilters {
	handle?: string;
	handleQrCode?: string;
	uuid?: string;
}
